module.exports = __webpack_public_path__ + "bdfd192a640285413fadc9820e9c49df.png";